module.exports = __webpack_public_path__ + "static/media/h6_lawlib.a853523c.webp";